var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "handover-option"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [(_vm.roleWiseScantally) ? _c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary",
    class: _vm.changeStatus == '1' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeStatus),
      expression: "changeStatus"
    }],
    staticClass: "custom-radio",
    attrs: {
      "type": "radio",
      "id": "ScanTally",
      "name": "ScanTally"
    },
    domProps: {
      "value": _vm.ScanTally,
      "checked": _vm._q(_vm.changeStatus, _vm.ScanTally)
    },
    on: {
      "click": _vm.clearAll,
      "change": function($event) {
        _vm.changeStatus = _vm.ScanTally
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Scan Tally ")])]) : _vm._e(), _vm._v(" "), (_vm.roleWiseAudit) ? _c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary",
    class: _vm.changeStatus == '0' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeStatus),
      expression: "changeStatus"
    }],
    staticClass: "custom-radio",
    attrs: {
      "type": "radio",
      "id": "Audit",
      "name": "Audit"
    },
    domProps: {
      "value": _vm.Audit,
      "checked": _vm._q(_vm.changeStatus, _vm.Audit)
    },
    on: {
      "click": _vm.clearAll,
      "change": function($event) {
        _vm.changeStatus = _vm.Audit
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Audit ScanTally ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('form', {
    staticStyle: {
      "margin-bottom": "-30px"
    },
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm2('form-2')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 0),
      expression: "changeStatus == 0"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("Exclude")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exclude),
      expression: "exclude"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('exclude')
    },
    attrs: {
      "name": "exclude",
      "id": "exclude"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.exclude = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.excludeList), function(exclude_obj) {
    return _c('option', {
      domProps: {
        "value": exclude_obj.eId
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(exclude_obj.excludeName))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.exclude')),
      expression: "errors.has('form-1.exclude')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select\n\t\t\t\t\t\t\t\t\t\tExclude")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("Include")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Include),
      expression: "Include"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Include')
    },
    attrs: {
      "name": "Include",
      "id": "Include"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Include = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.IncludeList), function(include_obj) {
    return _c('option', {
      domProps: {
        "value": include_obj.IncludeId
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(include_obj.IncludeName))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Include')),
      expression: "errors.has('form-1.Include')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select\n\t\t\t\t\t\t\t\t\t\tInclude")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("Select Date :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateobj.toDate),
      expression: "dateobj.toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "onkeydown": "event.preventDefault()",
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "max": _vm.formatDate(new Date())
    },
    domProps: {
      "value": (_vm.dateobj.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dateobj, "toDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.toDate')),
      expression: "errors.has('form-2.toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select To\n\t\t\t\t\t\t\t\t\t\tDate")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.showBatch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" Show Batches")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": _vm.generateBatch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Generate New Batch ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', {
    staticClass: "topspace"
  }, [_c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-undo",
    on: {
      "click": _vm.clear
    }
  }), _vm._v(" Reset\n\t\t\t\t\t\t\t\t\t\t\tBatch")])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.generateBatchLoader,
      "text": "Please wait batch is being generating.!"
    },
    on: {
      "update:active": function($event) {
        _vm.generateBatchLoader = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.errormsg), function(error) {
    return [(error.code != '200') ? _c('b-alert', {
      attrs: {
        "show": _vm.dismissCountDown,
        "dismissible": "",
        "fade": "",
        "variant": "danger"
      },
      on: {
        "dismiss-count-down": _vm.countDownChanged
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(error.message) + "\n\t\t\t\t\t\t\t\t\t")]) : _c('b-alert', {
      attrs: {
        "show": _vm.dismissCountDownSuccess,
        "dismissible": "",
        "fade": "",
        "variant": "success"
      },
      on: {
        "dismiss-count-down": _vm.countDownChangedSuccess
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(error.message) + "\n\t\t\t\t\t\t\t\t\t")])]
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBatchesFlag == true),
      expression: "showBatchesFlag == true"
    }],
    staticClass: "card-headerfrm123",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading,
      "text": "Please wait loading the batch.!"
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.generateBatchLoader,
      "text": "Please wait loading the batch.!"
    },
    on: {
      "update:active": function($event) {
        _vm.generateBatchLoader = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.downloadShipmentDetailsLoading,
      "text": "Please wait while .csv is downloading.!"
    },
    on: {
      "update:active": function($event) {
        _vm.downloadShipmentDetailsLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.getSummaryObj.length > 0) ? [_vm._l((_vm.getSummaryObj), function(getbatchtable, bidx) {
    return [_c('div', {
      staticClass: "card-headerfrm",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [(bidx == 0) ? _c('div', {}, [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('label', {
      staticClass: "linkcolor"
    }, [_vm._v("Total Batches : " + _vm._s(_vm.getSummaryObj.length) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('span', [_c('button', {
      staticClass: "btn btn-sm btn-primary mr-4",
      on: {
        "click": _vm.ReloadBatchData
      }
    }, [_c('i', {
      staticClass: "fa fa-undo"
    }), _vm._v(" Reload Batches ")])])]), _vm._v(" "), _c('b-alert', {
      attrs: {
        "show": _vm.dismissCountDownSuccessforSync,
        "dismissible": "",
        "fade": "",
        "variant": "success"
      },
      on: {
        "dismiss-count-down": _vm.countDownChangedSuccess
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tData is being sync in scantally, close batch after 5 minutes once the data has been\n\t\t\t\t\t\t\t\t\tsynced.!\n\t\t\t\t\t\t\t\t")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      class: bidx == 1 ? 'row' : 'row',
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_c('table', {
      staticClass: "batches table-bordered table-hover tbl datatables newscantally-tables",
      attrs: {
        "id": "batchTable",
        "cellpadding": "10",
        "cellspacing": "10"
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [_vm._l((getbatchtable), function(getObj) {
      return [(getObj.shipmenttype && getObj.GroupType == 'Regular') ? _c('tr', {
        key: getObj.shipmenttype + 'Regular'
      }, [_c('td', [_vm._v(_vm._s(getObj.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v("Regular")]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0' ? _vm.shipmentScanTallyList(getObj.BatchID, 'TotalShipmentCount', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'TotalShipmentCount')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'TotalScanShipments', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'TotalScanShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0' ? _vm.shipmentScanTallyList(getObj.BatchID, 'PendingInScan', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'PendingInScan')) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalOverageShipments', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'totalOverageShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalShortage', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'totalShortage')) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalRADShipments', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'totalRADShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'TotalOFDShipments', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'TotalOFDShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalLostShipments', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'totalLostShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalDamageShipments', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'totalDamageShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalSnatchedShipments', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'totalSnatchedShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalDeliveredShipments', getObj.shipmenttype, 'Regular') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Regular',
        'totalDeliveredShipments')))])]) : (getObj.shipmenttype && getObj.GroupType == 'Heavies') ? _c('tr', {
        key: getObj.shipmenttype + 'Heavies'
      }, [_c('td', [_vm._v(_vm._s(getObj.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v("Heavies")]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0' ? _vm.shipmentScanTallyList(getObj.BatchID, 'TotalShipmentCount', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'TotalShipmentCount')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'TotalScanShipments', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'TotalScanShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0' ? _vm.shipmentScanTallyList(getObj.BatchID, 'PendingInScan', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'PendingInScan')) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalOverageShipments', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'totalOverageShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalShortage', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'totalShortage')) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalRADShipments', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'totalRADShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'TotalOFDShipments', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'TotalOFDShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalLostShipments', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'totalLostShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '0' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalDamageShipments', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'totalDamageShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalSnatchedShipments', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'totalSnatchedShipments')))]), _vm._v(" "), _c('td', {
        class: {
          'linkcolor': getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1',
          'Closed-status-activity': getObj.Status.toLowerCase().trim() !== 'closed' && _vm.changeStatus !== '0'
        },
        on: {
          "click": function($event) {
            getObj.Status.toLowerCase().trim() == 'closed' || _vm.changeStatus == '1' ? _vm.shipmentScanTallyList(getObj.BatchID, 'totalDeliveredShipments', getObj.shipmenttype, 'Heavies') : null
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getData(getbatchtable, getObj.shipmenttype, 'Heavies',
        'totalDeliveredShipments')))])]) : _vm._e()]
    }), _vm._v(" "), [_c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'TotalShipmentCount')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'TotalScanShipments')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'PendingInScan')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'totalOverageShipments')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'totalShortage')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'totalRADShipments')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'TotalOFDShipments')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'totalLostShipments')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'totalDamageShipments')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'totalSnatchedShipments')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTotal(getbatchtable, 'totalDeliveredShipments')))])])]], 2)])]), _vm._v(" "), (bidx == 0) ? [_c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-top": "1rem"
      }
    }, [_c('div', {
      staticClass: "col-mt-2"
    }, [_c('div', [_c('span', {
      staticClass: "batch-info"
    }, [_vm._v(" Batch ID : ")]), _vm._v(" "), _c('label', [_vm._v(" " + _vm._s(getbatchtable[0].BatchID) + " ")])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "batch-info"
    }, [_vm._v(" Status : ")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(getbatchtable[0].Status) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', [_c('span', {
      staticClass: "batch-info"
    }, [_vm._v(" Created By : ")]), _vm._v(" "), _c('label', [_vm._v(" " + _vm._s(getbatchtable[0].CreatedBy) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "disabled": getbatchtable[0].Status == 'Closed'
      },
      on: {
        "click": function($event) {
          return _vm.scanShipments(getbatchtable[0].BatchID, getbatchtable[0].Status)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    }), _vm._v(" Scan Shipments ")]), _vm._v(" "), (getbatchtable[0].Status == 'ProcessDone') ? _c('button', {
      staticClass: "btn btn-sm btn-primary fa fa-fa-times",
      on: {
        "click": function($event) {
          return _vm.CloseBatch('Closed', getbatchtable[0].BatchID, getbatchtable, 'TotalOFDShipments')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Close Batch\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "disabled": getbatchtable[0].Status == 'ProcessDone'
      },
      on: {
        "click": function($event) {
          return _vm.exportShipmentData(getbatchtable[0].BatchID, 'ExportTotalShipment', true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Export total\n\t\t\t\t\t\t\t\t\t\tShipments")])])])] : [_c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-top": "1rem"
      }
    }, [_c('div', {
      staticClass: "col-mt-3"
    }, [_c('div', [_c('span', {
      staticClass: "batch-info"
    }, [_vm._v(" Batch ID : ")]), _vm._v(" "), _c('label', [_vm._v(" " + _vm._s(getbatchtable[0].BatchID) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('div', [_c('span', {
      staticClass: "batch-info"
    }, [_vm._v(" Created By : ")]), _vm._v(" "), _c('label', [_vm._v(" " + _vm._s(getbatchtable[0].CreatedBy) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('div', [_c('span', {
      staticClass: "batch-info"
    }, [_vm._v(" Status : ")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(getbatchtable[0].Status) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "disabled": getbatchtable[0].Status == 'ProcessDone'
      },
      on: {
        "click": function($event) {
          return _vm.exportShipmentData(getbatchtable[0].BatchID, 'ExportTotalShipment', true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Export total\n\t\t\t\t\t\t\t\t\t\tShipments")])])])]], 2)]
  })] : _vm._e(), _vm._v(" "), (_vm.getSummaryObj.length == 0) ? [_vm._m(2)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scanShipmentDiv"
    }
  }, [_c('form', {
    attrs: {
      "id": "inScanForm",
      "data-vv-scope": "form-1",
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanShipmentBatchFlag == true),
      expression: "scanShipmentBatchFlag == true"
    }],
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Batch No :")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.BatchNo))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" Shipment ID : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingId),
      expression: "shippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "ShippingID-styles shippingId",
    class: {
      'form-control': true,
      'error': _vm.errors.has('shippingId')
    },
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "oncopy": "return false",
      "onpaste": "return false",
      "name": "shippingId",
      "id": "shippingId",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.shippingId)
    },
    on: {
      "drop": _vm.handleDragOver,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shippingId')),
      expression: "errors.has('form-1.shippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter\n\t\t\t\t\t\t\t\tshippingID")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 1),
      expression: "changeStatus == 1"
    }],
    staticClass: "mannual"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Ismannual),
      expression: "Ismannual"
    }],
    ref: "ismannual",
    attrs: {
      "type": "checkbox",
      "name": "ismannual",
      "id": "ismannual",
      "disabled": _vm.SetReadonlyMode
    },
    domProps: {
      "checked": Array.isArray(_vm.Ismannual) ? _vm._i(_vm.Ismannual, null) > -1 : (_vm.Ismannual)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Ismannual,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.Ismannual = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.Ismannual = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.Ismannual = $$c
        }
      }, _vm.showUploadFileComments]
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "text-color": "black"
    }
  }, [_vm._v("Allow Manual entry ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 1 && _vm.checkValue == 1),
      expression: "changeStatus == 1 && checkValue == 1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.IsImageUploadRequired == true ? 'required' : ''))),
      expression: "`${IsImageUploadRequired == true ? 'required' : '' }`"
    }],
    ref: "uploadfile",
    staticStyle: {
      "width": "195px"
    },
    attrs: {
      "type": "file",
      "name": "uploadfile",
      "id": "uploadfile",
      "accept": ".png, .jpg, .jpeg, .gif, .bmp"
    },
    on: {
      "change": function($event) {
        return _vm.onuploadChange($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCloseButtonUpload),
      expression: "isCloseButtonUpload"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.resetFile
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    staticStyle: {
      "font-size": "24px"
    }
  })]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.uploadLoading,
      "text": "Please wait file upload is being proccessing.!"
    },
    on: {
      "update:active": function($event) {
        _vm.uploadLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.uploadfile')),
      expression: "errors.has('form-1.uploadfile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please select file\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invalidFile.value),
      expression: "invalidFile.value"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.invalidFile.errorMessage) + " ")])]), _vm._v(" "), (_vm.changeStatus == 1 && _vm.checkValue == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Comments:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.checkValue == '1' ? 'required': ''))),
      expression: "`${checkValue == '1' ? 'required': '' }`"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "name": "comments",
      "id": "comments"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.comments = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.commentsForManualEntry), function(comment_obj) {
    return _c('option', {
      domProps: {
        "value": comment_obj.text
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(comment_obj.text))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.comments')),
      expression: "errors.has('form-1.comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please Select comments\n\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.changeStatus == 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Comments")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "comments",
      "id": "comments"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.comments = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.commentsObjList), function(comment_obj) {
    return _c('option', {
      domProps: {
        "value": comment_obj.Reason
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(comment_obj.Reason))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "id": "submitControl",
      "type": "submit",
      "disabled": _vm.validated ? false : true
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.isCloseButtonUpload ? 'Scan & Upload' : 'Scan') + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.buttonReset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.InscanLoading,
      "text": "Please wait inscan is being proccessing.!"
    },
    on: {
      "update:active": function($event) {
        _vm.InscanLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), (_vm.imageListObject.length != 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 1),
      expression: "changeStatus == 1"
    }],
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "-80px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "collapsible",
    on: {
      "click": _vm.collapseUpslide
    }
  }, [_vm._v("Click To View Attachment "), _c('i', {
    class: _vm.toggleFlag == true ? 'fa fa-angle-up' : 'fa fa-angle-down',
    staticStyle: {
      "margin-left": "90px"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "width": "100%",
      "id": "hiddentable"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.imageListObject), function(singleobj) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "word-break": "break-all"
      }
    }, [_vm._v(_vm._s(singleobj.fileName))]), _vm._v(" "), _c('td', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.downloadFile(singleobj.filePath)
        }
      }
    }, [_vm._v(" Download")])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanFlag == true),
      expression: "scanFlag == true"
    }],
    staticClass: "col-md-12 scan-outputDetails",
    style: (_vm.styleObject),
    attrs: {
      "id": "InscanResponse"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.ScanMessage) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "Inscan-labels"
  }, [_vm._v(" " + _vm._s(_vm.getShipmentScanObj.ShippingID) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.ServiceType) + "\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")(_vm.getShipmentScanObj.PDD)) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.TotalAttemptCount) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.PendingDays) + "\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.ShipmentStatus) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.Status) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.SRDeliveryStatus) + "\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.NotificationType) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.NotificationStatus) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.ReAttemptDate) + "\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.LastComments) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 Inscan-labels"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getShipmentScanObj.subClusterName) + "\n\t\t\t\t\t\t\t\t")])])])])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "RVP Allocated Shipment",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "hidden": _vm.closeshipmentDetailsModel
    },
    model: {
      value: (_vm.shipmentDetailsModel),
      callback: function($$v) {
        _vm.shipmentDetailsModel = $$v
      },
      expression: "shipmentDetailsModel"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.ShipmentDetailsLoading
    },
    on: {
      "update:active": function($event) {
        _vm.ShipmentDetailsLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeshipmentDetailsModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row shipmentDetails",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v(" Shipment Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "linkcolor"
  }, [_vm._v(" Total Shipments ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t( " + _vm._s(this.shipmentStatusType) + " ) :\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('label', {
    staticClass: "linkcolor"
  }, [_vm._v(" " + _vm._s(_vm.getShipmentList.length) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '0'),
      expression: "changeStatus == '0'"
    }],
    staticClass: "linkcolor export-data",
    on: {
      "click": function($event) {
        return _vm.exportShipmentData(_vm.getModelBatchNo, _vm.shipmentStatusType, true)
      }
    }
  }, [_vm._v(" Export\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    class: {
      row: true,
      tableFixHead: true
    },
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto",
      "margin-left": "10px"
    }
  }, [_c('table', {
    ref: "ShipmentDetails",
    staticClass: "b-table batches table-bordered table-hover",
    attrs: {
      "id": "ShipmentDetails",
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('th', [_vm._v("BatchID")]), _vm._v(" "), _c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("ShipmentStatus")]), _vm._v(" "), _c('th', [_vm._v("CurrentHubName")]), _vm._v(" "), _c('th', [_vm._v("ScanTally InScan Date ")]), _vm._v(" "), _c('th', [_vm._v("NotificationType")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '1'),
      expression: "changeStatus == '1'"
    }]
  }, [_vm._v("IsSupplierPick")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '1'),
      expression: "changeStatus == '1'"
    }]
  }, [_vm._v("IsReversePick")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '0'),
      expression: "changeStatus == '0'"
    }]
  }, [_vm._v("Octroi MRP")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '0'),
      expression: "changeStatus == '0'"
    }]
  }, [_vm._v("Net Payment")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '0'),
      expression: "changeStatus == '0'"
    }]
  }, [_vm._v("ShippingDate")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '0'),
      expression: "changeStatus == '0'"
    }]
  }, [_vm._v("LastProcessDate")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '0'),
      expression: "changeStatus == '0'"
    }]
  }, [_vm._v("OrderType ")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == '0'),
      expression: "changeStatus == '0'"
    }]
  }, [_vm._v("GapDays")]), _vm._v(" "), _c('th', [_vm._v("Comments")])]), _vm._v(" "), _c('tbody', [(_vm.getShipmentList.length == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "14"
    }
  }, [_vm._v(" No Records Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getShipmentList), function(getShipment) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(getShipment.BatchID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(getShipment.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(getShipment.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(getShipment.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(getShipment.CurrentHubName))]), _vm._v(" "), (getShipment.IsInscan == 1) ? _c('td', [_vm._v(_vm._s(_vm._f("moment")(getShipment.LastModifiedDate)) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(getShipment.NotificationType))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.changeStatus == '1'),
        expression: "changeStatus == '1'"
      }]
    }, [_vm._v(_vm._s(getShipment.IsSupplierPick))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.changeStatus == '1'),
        expression: "changeStatus == '1'"
      }]
    }, [_vm._v(_vm._s(getShipment.IsReversePick))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.changeStatus == '0'),
        expression: "changeStatus == '0'"
      }]
    }, [_vm._v(_vm._s(getShipment.OctroiMRP))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.changeStatus == '0'),
        expression: "changeStatus == '0'"
      }]
    }, [_vm._v(_vm._s(getShipment.NetPayment))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.changeStatus == '0'),
        expression: "changeStatus == '0'"
      }]
    }, [_vm._v(_vm._s(_vm._f("moment")(getShipment.ShippingDate)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.changeStatus == '0'),
        expression: "changeStatus == '0'"
      }]
    }, [_vm._v(_vm._s(_vm._f("moment")(getShipment.LastProcessDate)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.changeStatus == '0'),
        expression: "changeStatus == '0'"
      }]
    }, [_vm._v(_vm._s(getShipment.OrderType))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.changeStatus == '0'),
        expression: "changeStatus == '0'"
      }]
    }, [_vm._v(_vm._s(getShipment.GapDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(getShipment.Comments))])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeshipmentDetailsModel
    }
  }, [_vm._v("Close")])])])])], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('legend', [_vm._v("Agent Scan - Tally")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("Shipment Sub-Type")]), _vm._v(" "), _c('th', [_vm._v("Total ScanTally Eligible")]), _vm._v(" "), _c('th', [_vm._v("Total Scanned")]), _vm._v(" "), _c('th', [_vm._v("Pending Scantally")]), _vm._v(" "), _c('th', [_vm._v("Overage")]), _vm._v(" "), _c('th', [_vm._v("Shortage")]), _vm._v(" "), _c('th', [_vm._v("RAD Shipments")]), _vm._v(" "), _c('th', [_vm._v("OFD/Status Pending")]), _vm._v(" "), _c('th', [_vm._v("Lost Marked")]), _vm._v(" "), _c('th', [_vm._v("Damaged")]), _vm._v(" "), _c('th', [_vm._v("Snatched")]), _vm._v(" "), _c('th', [_vm._v("Delivered")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_vm._v("No Batch Found..!!!")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead"
  }, [_c('th', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Download")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Scan Message :")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Shipping ID : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Service Type : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" PDD : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v(" Total Attempt Count : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Pending Days : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Shipment Status : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Status : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Delivery Status : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Notification Type : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v(" Notification status: ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" ReAttempt Date : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v(" Last Comments: ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Sub Cluster Name: ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3afd91dc","hasScoped":true}!./src/views/components/ScanTally/newAgentScanTally/newAgentScanTally.component.html
// module id = 1511
// module chunks = 1